import { Controller } from "@hotwired/stimulus"

// Opens or closes a modal located elsewhere in the DOM by CSS selector.
// Usage:
//   <button data-controller="trigger-modal"
//           data-trigger-modal-selector-value="#some-modal"
//           data-action="trigger-modal#open">
export default class extends Controller {
  static values = { selector: String }

  open() {
    this.#modalController()?.open()
  }

  close() {
    this.#modalController()?.close()
  }

  #modalController() {
    const el = document.querySelector(this.selectorValue)
    return el && this.application.getControllerForElementAndIdentifier(el, "modal")
  }
}
